/**
 * League card type constants
 * Used for player card rendering and classification
 */
export const League = {
  Bronze: 'bronze',
  Silver: 'silver',
  Gold: 'gold',
  InForm: 'inForm',
} as const;

export type LeagueType = typeof League[keyof typeof League];

/**
 * Division ladder milestone reward types.
 * CMS-only control: the backend stores only the reward fields the chosen type uses.
 */
export const MilestoneRewardType = {
  Both: 'BOTH',
  Pack: 'PACK',
  Coin: 'COIN',
} as const;

export type MilestoneRewardTypeValue = typeof MilestoneRewardType[keyof typeof MilestoneRewardType];
